export const SITE_URL = "https://fidexa.com.br";
export const PATH = "/alpha7";
/** Sem "| Fidexa": o titleTemplate de src/App.tsx acrescenta. */
export const TITLE = "Parceria Fidexa e Alpha7";
export const OG_TITLE = `${TITLE} | Fidexa`;
export const DESCRIPTION =
  "Indique uma farmácia da Alpha7 e ela passa a vender, atender e cobrar pelo WhatsApp oficial da Meta, sem risco de bloqueio do número. Demonstração gratuita.";

export const ALPHA7_SITE_URL = "https://a7.net.br";
export const ALPHA7_LEGAL_NAME = "Alpha7 Desenvolvimento de Software Ltda";

export const FIDEXA_LEGAL_NAME = "Fidexa Serviços de Crédito Ltda";
export const FIDEXA_CNPJ = "63.161.339/0001-90";

export const FORM_SECTION_ID = "indicacao";

/**
 * Fatos da copy — todos com fonte em
 * .claude/skills/seo/reference/fidexa-empresa.md (§4 e §6).
 */
export const METRICS = [
  {
    value: "R$ 39,34 mi",
    label: "recuperados para o varejo",
    hint: "em menos de um ano de operação",
  },
  { value: "249", label: "empresas cadastradas", hint: "redes e lojas únicas" },
  {
    value: "98%",
    label: "de leitura no WhatsApp",
    hint: "taxa de leitura das mensagens",
  },
] as const;

export const BENEFITS = [
  {
    title: "WhatsApp oficial, sem risco de bloqueio",
    description:
      "A Fidexa é parceira Meta e usa a API oficial do WhatsApp, com templates aprovados. O número da farmácia não corre o risco de banimento das soluções não oficiais.",
  },
  {
    title: "Campanhas de marketing",
    description:
      "Promoções, novidades e lembretes de recompra disparados para a base de clientes pelo número oficial, com o resultado de cada campanha medido.",
  },
  {
    title: "Auto-atendimento",
    description:
      "O cliente resolve o básico sozinho no WhatsApp, a qualquer hora, e só cai para uma pessoa do time quando precisa.",
  },
  {
    title: "Atendimento do time em um só lugar",
    description:
      "As conversas ficam organizadas entre os atendentes, com histórico por cliente, para ninguém responder duas vezes nem deixar mensagem sem resposta.",
  },
  {
    title: "Vários números num chat só",
    description:
      "A farmácia controla múltiplos números de WhatsApp num chat unificado, com o atendimento separado por loja.",
  },
  {
    title: "Cobrança e lembretes no automático",
    description:
      "Do aviso antes do vencimento ao acordo de parcelamento, a régua manda as mensagens sozinha e recebe por Pix na mesma conversa.",
  },
] as const;

export const STEPS = [
  {
    title: "Você indica a farmácia",
    description:
      "Preencha o formulário desta página com os dados do cliente e os seus.",
  },
  {
    title: "A Fidexa chama o responsável",
    description:
      "Um especialista entra em contato pelo WhatsApp informado e agenda uma demonstração gratuita.",
  },
  {
    title: "A operação começa a rodar",
    description:
      "Com o número conectado à API oficial, campanhas, atendimento e cobrança passam a sair do mesmo lugar.",
  },
] as const;
